import { ModuleType } from './baseTypes';
import { TrackingEventData, UIBaseCosmicObject } from './commons';

type CTAType = {
  key: string;
  value: string;
};

type CtaVariant = 'outlineWhite' | 'outline' | 'primary';

export const parseCtaVariant = (
  variant: CtaVariant | { value: CtaVariant }
): CtaVariant => {
  if (typeof variant === 'string') {
    return variant;
  }

  return variant.value;
};

export type CTACosmicMetadata = {
  text: string;
  href: string;
  with_border?: boolean;
  new_tab?: boolean;
  cta_type: CTAType;
  tracking_event: TrackingEventData;
  tracking_location?: string;
  move_up?: string;
  move_down?: string;
  variant?: { value: CtaVariant } | CtaVariant;
  cta_action?: string;
  cta_modal_variant?: 'small' | 'large';
  modal?: ModuleType & { metadata?: { isInModal?: boolean } };
};

export type CTAData = UIBaseCosmicObject<CTACosmicMetadata>;
